/**
 * Enum listing the different emitter rights on pins.
 */
export enum DsEmitterRightsEnum {
  ADD = 1,
  READ = 2,
  EDIT = 3,
  DONE = 4,
  NOT_DONE = 5,
  SUPPOSEDLY_DONE = 6,
  CHECKED_BUT_NOT_DONE = 7,
  SUPPOSEDLY_DONE_COMPANY = 8,
  PENDING = 9,
  SUPPOSEDLY_DONE_SST = 10,
  LINK_COMPANY = 11,
  COMMENT = 14,
}
